import * as React from "react";
import isNil from "lodash/isNil";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "&.MuiToggleButtonGroup-root": {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",

    " .MuiToggleButtonGroup-grouped": {
      margin: 0,
      border: 0,
      fontWeight: 600,

      [theme.breakpoints.up("sm")]: {
        fontSize: "20px",
      },
      fontSize: "16px",
      "&.MuiToggleButton-root": {
        background: "#2F2F37",
        color: "#fff",
        textTransform: "lowercase",
        borderRadius: "100px",
        "&:first-of-type": {
          marginLeft: "30px",
        },
        "&:last-of-type": {
          marginRight: "30px",
        },
      },
      "&.Mui-selected": {
        position: "relative",
        background:
          "linear-gradient(20deg, #73358F 0%, #BC3852 35%, #ED5736 75%, #E6824B 100%)",
        padding: "6px",
        "&:first-of-type": {
          marginLeft: 0,
        },
        "&:last-of-type": {
          marginRight: 0,
        },

        " > div": {
          background: "#fff",
          borderRadius: "100px",
          color: "#000",
          padding: "4px 22px",
          [theme.breakpoints.up("sm")]: {
            padding: "6px 28px",
          },

          " > span": {
            fontWeight: 800,
            fontSize: "20px",
            [theme.breakpoints.up("sm")]: {
              fontSize: "24px",
            },
            background:
              "linear-gradient(20deg, #73358F 0%, #BC3852 35%, #ED5736 75%, #E6824B 100%);",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
          },
        },
      },
      "&.Mui-disabled": {
        border: 0,
      },
    },
  },
}));

export default function AmountButtons({ amount, setFieldValue }: any) {
  const handleValueChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string
  ) => {
    if (isNil(newValue)) {
      return;
    }
    setFieldValue("amount", newValue, true);
  };

  return (
    <div>
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          background: "#2F2F37",
          color: "#fff",
          borderRadius: "100px",
        }}
      >
        <StyledToggleButtonGroup
          value={amount}
          exclusive
          onChange={handleValueChange}
          aria-label="text alignment"
        >
          <ToggleButton value="1" aria-label="left aligned">
            <div>
              <span>x1</span>
            </div>
          </ToggleButton>
          <ToggleButton value="2" aria-label="centered">
            <div>
              <span>x2</span>
            </div>
          </ToggleButton>
          <ToggleButton value="3" aria-label="right aligned">
            <div>
              <span>x3</span>
            </div>
          </ToggleButton>
          <ToggleButton value="4" aria-label="justified">
            <div>
              <span>x4</span>
            </div>
          </ToggleButton>
        </StyledToggleButtonGroup>
      </Paper>
    </div>
  );
}
